const Segment = ({ options, value, onChange }) => {
  return (
    <div className="rounded-xl bg-white border dark:border-gray-700 overflow-hidden divide-x divide-gray-100 dark:divide-gray-700">
      {options.map((option) => (
        <button
          key={option.value}
          className={`px-3 py-2
              ${
                option.value === value
                  ? "bg-blue-50 text-blue-600 dark:bg-gray-700 dark:text-blue-300"
                  : "text-gray-600 dark:text-gray-300"
              }`}
          onClick={() => onChange(option.value)}
          title={option.label}
        >
          <span>{option.icon}</span>
          <span>{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default Segment;
